import { render } from "./App.vue?vue&type=template&id=cddb5368&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=cddb5368&lang=scss"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__